import * as React from 'react';

import { cn } from '@/lib/cn';
import { FOCUS_RING } from './kit';

export interface PressableProps extends React.ComponentProps<'button'> {
  /** Set to false when the caller draws its own focus indicator. */
  focusRing?: boolean;
}

/**
 * A clickable area that is NOT a visual button: tree rows, list rows,
 * thumbnails and tiles, color swatches, drag handles, selectable chips, "+"
 * hit areas between items. It renders a native `<button type="button">`,
 * forwards the ref and every prop, adds the kit focus ring and nothing else:
 * the caller owns the look through `className`.
 *
 * Use `Button` instead when the element reads as an action (filled or outlined
 * box with a label and/or icon): it brings the variants, sizes, loading state
 * and icon tooltip.
 */
export function Pressable({ className, type, focusRing = true, ref, ...props }: PressableProps) {
  return (
    <button
      ref={ref}
      type={type ?? 'button'}
      data-slot="pressable"
      data-ring={focusRing ? '' : undefined}
      className={cn(focusRing && FOCUS_RING, className)}
      {...props}
    />
  );
}
